import {
  GET_ALL_COUNTRY_FAIL,
  GET_ALL_COUNTRY_REQUEST,
  GET_ALL_COUNTRY_SUCCESS,
  GET_SINGLE_COUNTRY_FAIL,
  GET_SINGLE_COUNTRY_REQUEST,
  GET_SINGLE_COUNTRY_SUCCESS,
  ADD_COUNTRY_FAIL,
  ADD_COUNTRY_REQUEST,
  ADD_COUNTRY_SUCCESS,
  UPDATE_COUNTRY_FAIL,
  UPDATE_COUNTRY_REQUEST,
  UPDATE_COUNTRY_SUCCESS,
  DELETE_COUNTRY_SUCCESS,
  DELETE_COUNTRY_REQUEST,
  DELETE_COUNTRY_FAIL,
} from "../constant/CountryConstant";
const initialState = {
  loading: false,
  action: "Country",
  result: [],
  singledata: [],
  message: "",
  error: "",
  success: false,
};

const CountryReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_COUNTRY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_ALL_COUNTRY_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload.data,
        message: action.payload,
      };
    case GET_ALL_COUNTRY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case GET_SINGLE_COUNTRY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_SINGLE_COUNTRY_SUCCESS:
      return {
        ...state,
        loading: false,
        singledata: action.payload.data,

        message: action.payload,
      };
    case GET_SINGLE_COUNTRY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        message: action.payload,
      };

    case ADD_COUNTRY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ADD_COUNTRY_SUCCESS:
      return {
        ...state,
        loading: false,
        result: state.result.filter((items) =>
          items.id === action.payload.id
            ? Object.assign({}, items, action.payload)
            : items
        ),
        success: true,
        message: action.payload,
      };
    case ADD_COUNTRY_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
        message: action.payload,
      };

    case UPDATE_COUNTRY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_COUNTRY_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        result: state.result.map((items) =>
          items.id === action.payload.id
            ? Object.assign({}, items, action.payload)
            : items
        ),
        message: action.payload,
      };
    case UPDATE_COUNTRY_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };
    case DELETE_COUNTRY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DELETE_COUNTRY_SUCCESS:
      return {
        ...state,
        loading: false,
        result: state.result.filter((item) => item.id !== action.payload.id),
        message: action.payload,
      };
    case DELETE_COUNTRY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        message: action.payload,
      };
    default:
      return state;
  }
};

export default CountryReducer;
